import dayjs from "dayjs";

import { UserEntityPreferredLanguage } from "@/api/__generated__/orval/auth";

export const getHumainDurationFromNow = (
  date: Date,
  locale?: UserEntityPreferredLanguage
) => {
  const resolvedLocale = locale || UserEntityPreferredLanguage.en;
  return dayjs(date).locale(resolvedLocale).fromNow();
};
